import api from './api';

export const getListaFornecedores = async () => {
  try {
    const data = await api.get('/Fornecedor/list');
    return data;
  } catch (error) {
    return { error };
  }
};

export const getListaTipoCadastros = async () => {
  try {
    const data = await api.get('/TipoCadastro/list');
    return data;
  } catch (error) {
    return { error };
  }
};

export const getListaConsultas = async () => {
  try {
    const data = await api.get('/Consulta/list?NumeroRegistros=100');
    return data;
  } catch (error) {
    return { error };
  }
};

export const deletarConsulta = async id => {
  try {
    const data = api.delete(`/Consulta?id=${id}`);
    return data;
  } catch (error) {
    return { error };
  }
};

export const criarConsulta = async consulta => {
  try {
    const data = api.post('/Consulta', consulta);
    return data;
  } catch (error) {
    return { error };
  }
};

export const editarConsulta = async consulta => {
  try {
    const data = api.put('/Consulta', consulta);
    return data;
  } catch (error) {
    return { error };
  }
};

export const getDadosCadastraisConsulta = async id => {
  try {
    const data = api.get(
      `/Consulta/dados-cadastrais-consulta?idConsulta=${id}`
    );
    return data;
  } catch (error) {
    return { error };
  }
};

export const getRazoesReprovacao = () => {
  try {
    const data = api.get('/Consulta/razoes-reprovacao');
    return data;
  } catch (error) {
    return { error };
  }
};
